<template>
  <div id="table-inner-container">
    <table id="table-content" class="result-list-table">
      <thead>
        <tr>
          <th class="primary"><span>{{ strings.tableColumnName}}</span></th>
          <th class="" data-hide-at="720"><span>{{ strings.tableColumnCreator}}</span></th>
          <th class="value" data-hide-at="912"><span>{{ strings.tableColumnModified}}</span></th>
          <th class="value" data-hide-at="1024"><span>{{ strings.tableColumnCreated}}</span></th>
          <th class="value sorted"><span>{{ strings.tableColumnAccessed}}</span></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(workspace) in allWorkspaces"
          v-bind:key="workspace.Id"
          :data-workspace-id="workspace.Id"
          @click="handleGoToWorkspace(workspace.Id)">
          <td :title="workspace.Name" class="primary">
            <div class="name">
              <a :href="getWorkspaceURL(workspace.Id)" @click="handleGoToWorkspace(workspace.Id)">{{ workspace.Name }}</a>
              <span v-if="workspace.Permission !== 'FullAccess'" class="access">{{ getFormattedAccess(workspace.Permission) }}</span>
            </div>
          </td>
          <td :title="getCreator(workspace.Creator)" data-hide-at="720">
            <span>{{ getCreator(workspace.Creator) }}</span>
          </td>
          <td :title="getLongDate(workspace.ModifiedDate)" class="value" data-hide-at="912">
            <span>{{ getRegularDate(workspace.ModifiedDate) }}</span>
          </td>
          <td :title="getLongDate(workspace.CreatedDate)" class="value" data-hide-at="1024">
            <span>{{ getRegularDate(workspace.CreatedDate) }}</span>
          </td>
          <td :title="getLongDate(workspace.LastAccessedByUserDate)" class="value">
            <span>{{ getRegularDate(workspace.LastAccessedByUserDate) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="table-controls">
      <page-button v-if="moreAvailable" :title="strings.loadMoreWorkspaces" id="load-more-btn" class="button" @click="requestMore">{{ strings.loadMoreWorkspaces }}</page-button>
    </div>
  </div>
</template>

<script>
import { URLS } from '@/utils/urls'
import { Formatters } from '@/utils/formatters'

import navigation from '@/utils/navigation'
import { mapActions, mapGetters } from 'vuex'

import PageButton from '@/components/common/Page-Button'


export default {
  data () {
    return {
      strings: {
        loadMoreWorkspaces: this.translate('load more workspaces'),
        tableColumnName: this.translate('table column name'),
        tableColumnCreator: this.translate('table column creator'),
        tableColumnModified: this.translate('table column modified'),
        tableColumnCreated: this.translate('table column created'),
        tableColumnAccessed: this.translate('table column accessed'),
        accessFullAccess: this.translate('access fullaccess'),
        accessReadOnly: this.translate('access readonly'),
        accessLocked: this.translate('access locked')
      }
    }
  },
  components: {
    'page-button': PageButton,
  },
  props: {
    status: {
      type: Boolean,
      required: true
    },
    action: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      allWorkspaces: 'workspaces/allWorkspaces'
    }),
    moreAvailable () {
      return this.status
    }
  },
  methods: {
    requestMore () {
      this.action()
    },
    handleGoToWorkspace (workspaceId) {
      navigation.redirect(URLS.App.Open.Workspace(workspaceId))
    },
    getCreator (creator) {
      return (creator) ? `${creator.FirstName} ${creator.LastName}` : '—'
    },
    getWorkspaceURL (workspaceId) {
      return URLS.App.Open.Workspace(workspaceId)
    },
    getLongDate (date) {
      return Formatters.DateTime.Long(date)
    },
    getRegularDate (date) {
      return Formatters.DateTime.Regular(date)
    },
    getFormattedAccess (access) {
      return Formatters.Access(access)
    },
    translate (string, object) {
      return this.$i18n.translate(string, object)
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/components/home/_home-table.scss";
</style>
